import { ChangeEvent } from "react";
import { FiUser, FiMail, FiPhone } from "react-icons/fi";
import utils from "../../helpers/utils";

interface PersonalDataStepProps {
  form: {
    first_name: string;
    email: string;
    phone: string;
  };
  accentColor: string;
  onChange: (target: { name: string; value: string }) => void;
}

function PersonalDataStep({
  form,
  accentColor,
  onChange,
}: PersonalDataStepProps) {
  return (
    <div className="space-y-5 animate-fadeIn">
      <div className="text-center mb-6">
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Precisamos de algumas informações básicas
        </p>
      </div>

      <div>
        <label className="mb-2 block text-sm font-medium text-black dark:text-white">
          Nome completo <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <FiUser
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
            size={18}
          />
          <input
            type="text"
            name="first_name"
            autoFocus
            required
            value={form.first_name}
            onChange={({ target }: ChangeEvent<HTMLInputElement>) =>
              onChange(target)
            }
            className="w-full rounded-xl border border-stroke bg-transparent pl-12 pr-4 py-3.5 text-sm outline-none transition focus:border-2 dark:border-form-strokedark dark:bg-form-input dark:text-white"
            style={{
              borderColor: form.first_name ? accentColor : undefined,
            }}
            placeholder="Digite seu nome completo"
          />
        </div>
      </div>

      <div>
        <label className="mb-2 block text-sm font-medium text-black dark:text-white">
          E-mail <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <FiMail
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
            size={18}
          />
          <input
            type="email"
            name="email"
            required
            value={form.email}
            onChange={({ target }: ChangeEvent<HTMLInputElement>) =>
              onChange(target)
            }
            className="w-full rounded-xl border border-stroke bg-transparent pl-12 pr-4 py-3.5 text-sm outline-none transition focus:border-2 dark:border-form-strokedark dark:bg-form-input dark:text-white"
            style={{
              borderColor: form.email ? accentColor : undefined,
            }}
            placeholder="seu@email.com"
          />
        </div>
      </div>

      <div>
        <label className="mb-2 block text-sm font-medium text-black dark:text-white">
          Telefone <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <FiPhone
            className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
            size={18}
          />
          <input
            type="text"
            name="phone"
            required
            maxLength={16}
            placeholder="(00) 00000-0000"
            value={form.phone ? utils.formatarTelefone(form.phone) : ""}
            onChange={({ target }: ChangeEvent<HTMLInputElement>) =>
              onChange(target)
            }
            className="w-full rounded-xl border border-stroke bg-transparent pl-12 pr-4 py-3.5 text-sm outline-none transition focus:border-2 dark:border-form-strokedark dark:bg-form-input dark:text-white"
            style={{
              borderColor: form.phone ? accentColor : undefined,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default PersonalDataStep;
